export default __webpack_public_path__ + "static/media/logo.d6698995.png";